// extracted by mini-css-extract-plugin
module.exports = {"login-background":"_1yQWxg9CKXg00KRPyA6G3m","footer":"K_YeesVHyYOTe1_LLrrCT","button":"_1ncTZAXxdy_vE1ppQHxA92"};